import { render, staticRenderFns } from "./DemoRoster.vue?vue&type=template&id=3cf5ce3b"
import script from "./DemoRoster.vue?vue&type=script&lang=ts"
export * from "./DemoRoster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports